/* eslint-disable no-console */
/* eslint-disable radix */
/* eslint-disable eqeqeq */
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
/* eslint-disable no-plusplus */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-script-url */
/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-undef */
/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-no-undef */
/* eslint-disable no-param-reassign */
/* eslint-disable array-callback-return */
/* eslint-disable camelcase */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable react/button-has-type */
/* eslint-disable react/style-prop-object */
/* eslint-disable max-len */
import React, {
    useEffect, useCallback, useState, useContext,
} from 'react';
import moment from 'moment';
import { Link, useParams, useNavigate } from 'react-router-dom';
import { GenerateDate, GenerateDateandTime, generateDateWithTime } from '../../redux/helper/DateConverter';
import HeaderContext from '../../Components/Context/HeaderContext';
import { distributorService } from '../../service/distributor.service';
import ApprovedOrdersDistributorDetails from './Components/Distributor/DistributorDetails';
import ApprovedOrderProductDetails from './Components/ProductDetails';
import EUBSummary from './Components/OrderSummary/EUBSummary';
import TradeSummary from './Components/OrderSummary/TradeSummary';
import DistributorComments from './Components/Distributor/distributorComments';
import RelatedDocuments from './Components/RelatedDocument';
import AssignedASE from './Components/AssignedASE';
import Invoices from './Components/Invoices/invoices';
import ViewApprovedOrderSkeleton from '../../Components/Skeletons/viewApprovedOrderSkeleton';
import DirectOrderSummary from './Components/OrderSummary/DirectOrderSummary';
import EmptyScreen from '../../Components/GlobalEmplyPage';
import TransferHistory from '../ManagerOrders/Components/TransferHistory';

function ViewApprovedOrdersDetails() {
    const navigate = useNavigate();
    const { orderId, distributorId } = useParams();
    const [OrderDetails, setOrderDetails] = useState({});
    const [invoiceDetails, setInvoiceDetails] = useState({});
    const [YesUpdate, setYesUpdate] = useState(false);
    const [ThreelPl, setThreelPl] = useState([]);
    const [UserRole, setUserRole] = useState('');
    const {
        isPopup,
        setisPopup,
        ErrorMessage,
        SetErrorMessage,
        SuccessMessage,
        SetSuccessMessage,
        colorValue,
        setcolorValue,
        HardRefresh,
        setHardRefresh,
        collapsed,
    } = useContext(HeaderContext);
    const [loading, setloading] = useState(true);
    const [tabToggle, setTabToggle] = useState('products');

    const order_status = {
        0: 'Draft',
        1: 'Pending',
        2: 'InProcess',
        3: 'Approved',
        4: 'Out for delivery',
        5: 'partially delivered',
        6: 'deliverd',
        7: 'completed',
        8: 'Cancelled',
        9: 'Cancelled',
    };

    const payment_status = {
        0: 'Pending',
        1: 'Partial',
        2: 'Paid',
    };

    const handleFetch = useCallback(
        async () => {
            const details = await distributorService.ViewOrderDetails(orderId, distributorId);
            if (!details?.error && details?.data?.success_status) {
                setOrderDetails(details?.data?.data);
                const current = JSON.parse(localStorage.getItem('user')).profile.roles;
                setUserRole(current);
                setloading(false);
            } else {
                // handleErrorMessage(details?.data.message);
                setloading(false);
            }
        },
        [YesUpdate, orderId],
    );
    const handleFetchOrderInvoiceDetails = useCallback(
        async () => {
            const res = await distributorService.OrderInvoiceDetails(orderId, distributorId);
            if (res?.data?.data?.length > 0) {
                setInvoiceDetails(res?.data?.data);
            }
        },
    );

    const handleNavigate = () => {
        navigate(-1);
    };

    useEffect(() => {
        handleFetch();
    }, [handleFetch]);

    useEffect(() => {
        handleFetchOrderInvoiceDetails();
    }, []);

    const getDispatchDate = () => {
        const leadTimeArray = [];
        for (const key in OrderDetails?.items) {
            for (let index = 0; index < OrderDetails?.items[key].length; index++) {
                leadTimeArray.push(OrderDetails?.items[key][index].DELIVERY_LEAD_TIME);
            }
        }
        let result = leadTimeArray[0];
        for (let i = 1; i < leadTimeArray.length; i++) {
            if (leadTimeArray[i] != null) {
                result = result > leadTimeArray[i] ? result : leadTimeArray[i];
            }
        }
        if (result == 'A') {
            return moment.unix(parseInt(OrderDetails?.order_acceptance_date !== null ? OrderDetails?.order_acceptance_date : OrderDetails?.created_at)).add(10, 'd').format('DD-MMM-YYYY');
        } if (result == 'B') {
            return moment.unix(parseInt(OrderDetails?.order_acceptance_date !== null ? OrderDetails?.order_acceptance_date : OrderDetails?.created_at)).add(21, 'd').format('DD-MMM-YYYY');
        } if (result == 'C') return moment.unix(parseInt(OrderDetails?.order_acceptance_date !== null ? OrderDetails?.order_acceptance_date : OrderDetails?.created_at)).add(45, 'd').format('DD-MMM-YYYY');
        return '-';
    };

    return (
        <div>
            {loading ? <ViewApprovedOrderSkeleton />
                : (
                    <>
                        <div className="flex items-center sticky top-[94px] w-full pt-6 bg-[#FFFFFF] z-[99]">
                            <div onClick={() => handleNavigate()} className="cursor-pointer">
                                <img
                                    src="/images/Icon-feather-arrow-left-gray.svg"
                                    alt="icon"
                                    loading="lazy"
                                    decoding="async"
                                    data-testid="back-btn"
                                />
                            </div>
                            <p className="text-lg font-normal text-[#555259] pl-3.5">
                                Order Details
                            </p>
                        </div>
                        <div className="flex mt-5 h-full overflow-y-auto overflow-x-hidden">
                            <div className="w-[70%] mr-5">
                                <div className="flex -mx-1 mt-1 items-center">
                                    <div className="w-2/5 px-1">
                                        <div>
                                            <p className="text-sm font-semibold text-[#777777]">Order Number</p>
                                            <div className="flex items-center">
                                                <p className="text-xs24 font-semibold text-[#090406] pt-0.5" data-testid="order-number">
                                                    {OrderDetails?.order_initial_number}
                                                </p>
                                                <p className="ml-6 p-1 bg-[#44445E] rounded text-xs3 font-normal text-[#FFFFFF]">
                                                    from
                                                    {' '}
                                                    {OrderDetails?.order_from}
                                                </p>
                                                {OrderDetails?.subscription_id !== null
                                                    && (
                                                        <p className="ml-2 p-1 bg-[#44445E] rounded text-xs3 font-normal text-[#FFFFFF]">
                                                            Bulk
                                                        </p>
                                                    )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="sm:py-2 py-1 mt-6 px-3 bg-[#F5F5FA] rounded-lg  flex gap-3 justify-between items-center w-full flex-wrap">
                                    <div className="">
                                        <p className="text-[#777777] font-semibold text-xs text-center">Indent Number</p>
                                        <p className="font-normal sm:text-lg text-sm text-[#090406] text-center" data-testid="indent-number">{OrderDetails?.order_number}</p>
                                    </div>
                                    <div className=" ">
                                        <p className="text-[#777777] font-semibold text-xs text-center">Order Status</p>
                                        <p className="font-normal sm:text-lg text-sm text-[#090406] text-center" data-testid="order-status">{order_status[OrderDetails?.status]}</p>
                                    </div>
                                    {order_status[OrderDetails?.status] === 'Cancelled' && (
                                        <div className=" ">
                                            <p className="text-[#777777] font-semibold text-xs text-center">Order Cancelled By</p>
                                            <p className="font-normal sm:text-lg text-sm text-[#090406] text-center">{`${OrderDetails?.order_cancelled_by?.employee_code || ''} - ${OrderDetails?.order_cancelled_by?.first_name || ''} ${OrderDetails?.order_cancelled_by?.last_name || ''}`}</p>
                                        </div>
                                    )}
                                    <div className=" ">
                                        <p className="text-[#777777] font-semibold text-xs text-center">Plant Name</p>
                                        {(Object.keys(OrderDetails?.plant_info || {}).length) > 0
                                            ? <p className="font-normal sm:text-lg text-sm text-[#090406] text-center" data-testid="plant-name">{OrderDetails?.plant_info?.DESCRIPTION}</p>
                                            : <p className="font-normal sm:text-lg text-sm text-[#090406] text-center">-</p>}
                                    </div>
                                    <div className=" ">
                                        <p className="text-[#777777] font-semibold text-xs text-center">Order Created</p>
                                        <p className="font-normal sm:text-lg text-sm text-[#090406] text-center" data-testid="order-date">{GenerateDateandTime(OrderDetails?.created_at)}</p>
                                    </div>
                                    <div className=" ">
                                        <p className="text-[#777777] font-semibold text-xs text-center">Expected Dispatch</p>
                                        <p className="font-normal sm:text-lg text-sm text-[#090406] sm:text-center text-start">
                                            {getDispatchDate()}
                                        </p>
                                    </div>
                                    <div className=" ">
                                        <p className="text-[#777777] font-semibold text-xs text-center">ICD Number</p>
                                        <p className="font-normal sm:text-lg text-sm text-[#090406] sm:text-center text-start">
                                            {OrderDetails?.icd_number || '-'}
                                        </p>
                                    </div>
                                </div>
                                <div className="flex">
                                    <div className="w-[55%]">
                                        <p className="text-xs6 text-[#090406] font-semibold my-3">Payment Details</p>
                                        <div className="sm:py-2 py-1 px-3 bg-[#F5F5FA] rounded-lg flex justify-between items-center lg:flex-nowrap flex-wrap">
                                            <div className="mr-2">
                                                <p className="text-[#777777] font-semibold text-xs">Type</p>
                                                <p className="font-normal sm:text-lg text-sm text-[#090406]">{OrderDetails?.payment_info?.type}</p>
                                            </div>
                                            <div className="mr-2">
                                                <p className="text-[#777777] font-semibold text-xs">Status</p>
                                                <p className="font-normal sm:text-lg text-sm text-[#090406]">{payment_status[OrderDetails?.payment_info?.status]}</p>
                                            </div>
                                            <div className="mr-2">
                                                <p className="text-[#777777] font-semibold text-xs">Due Date for Advance Payment</p>
                                                {OrderDetails?.payment_info?.due_date_advance_payment === ''
                                                    ? <p className="font-normal sm:text-lg text-sm text-[#090406] ml-[80px]">-</p>
                                                    : <p className="font-normal sm:text-lg text-sm text-[#090406]">{OrderDetails?.payment_info?.due_date_advance_payment}</p>}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="w-[45%] ml-2">
                                        <p className="text-xs6 text-[#090406] font-semibold my-3">Order Confirmation</p>
                                        <div className="sm:py-2 py-1 px-3 bg-[#F5F5FA] rounded-lg flex justify-between items-center lg:flex-nowrap flex-wrap">
                                            <div className="mr-2">
                                                <p className="text-[#777777] font-semibold text-xs">Order Acceptance No.</p>
                                                <p className="font-normal sm:text-lg text-sm text-[#090406]" data-testid="acceptance-number">{OrderDetails?.order_info !== undefined && OrderDetails?.order_info !== null ? OrderDetails?.order_info[0]?.ORDER_NUMBER : '-'}</p>
                                            </div>
                                            <div className="mr-2">
                                                <p className="text-[#777777] font-semibold text-xs">Order Acceptance Date</p>
                                                <p className="font-normal sm:text-lg text-sm text-[#090406]">{OrderDetails?.order_info !== undefined && OrderDetails?.order_info !== null ? OrderDetails.order_info[0]?.ORDER_ACCEPTANCE_DATE : '-'}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <p className="text-xs6 text-[#090406] font-semibold my-1.5">Address</p>
                                <div className="sm:py-2 py-1 mt-2 sm:px-7 px-2.5 bg-[#F5F5FA] rounded-lg  flex justify-between items-center lg:flex-nowrap flex-wrap">
                                    <div className="flex">
                                        <div className="w-1/2 pr-[20px]">
                                            <p className="font-semibold text-[#777777] text-xs">Billing Address</p>
                                            {(OrderDetails?.items[Object.keys(OrderDetails?.items)[0]].length) > 0
                                                && (
                                                    <p className="font-normal text-base text-[#090406]">
                                                        {(OrderDetails?.items[Object.keys(OrderDetails?.items)[0]][0]?.BILLING_ADDRESS?.ADDRESS1)}
                                                        {' '}
                                                        {(OrderDetails?.items[Object.keys(OrderDetails?.items)[0]][0]?.BILLING_ADDRESS?.ADDRESS2)}
                                                        {' '}
                                                        {(OrderDetails?.items[Object.keys(OrderDetails?.items)[0]][0]?.BILLING_ADDRESS?.ADDRESS3)}
                                                        {' '}
                                                        {(OrderDetails?.items[Object.keys(OrderDetails?.items)[0]][0]?.BILLING_ADDRESS?.ADDRESS4)}
                                                        ,
                                                        {(OrderDetails?.items[Object.keys(OrderDetails?.items)[0]][0]?.BILLING_ADDRESS?.CITY)}
                                                        -
                                                        {(OrderDetails?.items[Object.keys(OrderDetails?.items)[0]][0]?.BILLING_ADDRESS?.POSTAL_CODE)}
                                                        ,
                                                        {(OrderDetails?.items[Object.keys(OrderDetails?.items)[0]][0]?.BILLING_ADDRESS?.STATE)}
                                                        ,
                                                        Location-
                                                        {(OrderDetails?.items[Object.keys(OrderDetails?.items)[0]][0]?.BILLING_ADDRESS?.LOCATION)}
                                                        ,
                                                        GSTIN-
                                                        {(OrderDetails?.items[Object.keys(OrderDetails?.items)[0]][0].BILLING_ADDRESS?.ATTRIBUTE2)}
                                                    </p>
                                                )}
                                        </div>
                                        <div className="w-1/2">
                                            <p className="font-semibold text-[#777777] text-xs">Shipping Address</p>
                                            {(OrderDetails?.items[Object.keys(OrderDetails?.items)[0]].length) > 0
                                                && (
                                                    <p className="font-normal text-base text-[#090406]">
                                                        {(OrderDetails?.items[Object.keys(OrderDetails?.items)[0]][0]?.SHIPPING_ADDRESS?.ADDRESS1)}
                                                        {' '}
                                                        {(OrderDetails?.items[Object.keys(OrderDetails?.items)[0]][0]?.SHIPPING_ADDRESS?.ADDRESS2)}
                                                        {' '}
                                                        {(OrderDetails?.items[Object.keys(OrderDetails?.items)[0]][0]?.SHIPPING_ADDRESS?.ADDRESS3)}
                                                        {' '}
                                                        {(OrderDetails?.items[Object.keys(OrderDetails?.items)[0]][0]?.SHIPPING_ADDRESS?.ADDRESS4)}
                                                        ,
                                                        {(OrderDetails?.items[Object.keys(OrderDetails?.items)[0]][0]?.SHIPPING_ADDRESS?.CITY)}
                                                        -
                                                        {(OrderDetails?.items[Object.keys(OrderDetails?.items)[0]][0]?.SHIPPING_ADDRESS?.POSTAL_CODE)}
                                                        ,
                                                        {(OrderDetails?.items[Object.keys(OrderDetails?.items)[0]][0]?.SHIPPING_ADDRESS?.STATE)}
                                                        ,
                                                        Location-
                                                        {(OrderDetails?.items[Object.keys(OrderDetails?.items)[0]][0]?.SHIPPING_ADDRESS?.LOCATION)}
                                                        ,
                                                        GSTIN-
                                                        {(OrderDetails?.items[Object.keys(OrderDetails?.items)[0]][0]?.SHIPPING_ADDRESS?.ATTRIBUTE2)}
                                                    </p>
                                                )}
                                        </div>
                                    </div>
                                </div>
                                <ul className="nav nav-pills flex flex-row list-none pl-0 mb-4 mt-5 =" id="pills-tab" role="tablist">
                                    <li onClick={() => setTabToggle('products')} className="nav-item mr-[70px]" role="presentation">
                                        <a href="javascript:void(0)" className={`nav-link block ${tabToggle === 'products' ? 'active' : ''} font-semibold text-xs25 text-[#707070] invoices relative`} id="pills-home1-tab" data-bs-toggle="pill" data-bs-target="#pills-home1" role="tab" aria-controls="pills-home1" aria-selected="true">
                                            Products(
                                            {Object.values(OrderDetails?.items)[0].length}
                                            )
                                        </a>
                                    </li>
                                    <li onClick={() => setTabToggle('invoices')} className="nav-item" role="presentation">
                                        <a href="javascript:void(0)" className={`nav-link ${tabToggle === 'invoices' ? 'active' : ''} invoices font-semibold text-xs25 text-[#707070] relative block`} id="pills-profile1-tab" data-bs-toggle="pill" data-bs-target="#pills-profile1" role="tab" aria-controls="pills-profile1" aria-selected="false">
                                            {invoiceDetails.length > 0
                                                ? (
                                                    <div>
                                                        {' '}
                                                        Invoices(
                                                        {invoiceDetails.length}
                                                        )

                                                    </div>
                                                )
                                                : (
                                                    <div>
                                                        Invoices
                                                    </div>
                                                )}

                                        </a>
                                    </li>
                                </ul>
                                <div className="tab-content" id="pills-tabContent">
                                    <div className={`tab-pane fade ${tabToggle === 'products' ? 'show active' : ''}`} id="pills-home1" role="tabpanel" aria-labelledby="pills-home1-tab">
                                        <div className="flex lg:flex-row flex-col">
                                            <div className="w-full">
                                                {OrderDetails?.items && Object?.values(OrderDetails?.items).map((item, i) => (
                                                    <div className="w-full h-[700px] custom-scrollbar">
                                                        {item.map((prod) => (
                                                            <ApprovedOrderProductDetails
                                                                prod={prod}
                                                                OrderDetails={OrderDetails}
                                                                setOrderDetails={setOrderDetails}
                                                            />
                                                        ))}
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                    <div className={`tab-pane fade ${tabToggle === 'invoices' ? 'show active' : ''}`} id="pills-home1" role="tabpanel" aria-labelledby="pills-home1-tab">
                                        <div className="flex lg:flex-row flex-col">
                                            {invoiceDetails.length > 0
                                                ? (
                                                    <div>
                                                        <Invoices
                                                            OrderDetails={OrderDetails}
                                                            invoiceDetails={invoiceDetails}
                                                            setInvoiceDetails={setInvoiceDetails}
                                                        />
                                                    </div>
                                                )
                                                : (
                                                    <div className="w-full">
                                                        <EmptyScreen
                                                            text="No Invoices"
                                                        />
                                                    </div>
                                                )}
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div className="w-[30%]">
                                <AssignedASE OrderDetails={OrderDetails} />
                                {OrderDetails?.order_type === 'Trade EUB'
                                    ? <EUBSummary OrderDetails={OrderDetails} /> : OrderDetails.order_type === 'Trade'
                                        ? <TradeSummary OrderDetails={OrderDetails} /> : <DirectOrderSummary OrderDetails={OrderDetails} />}

                                {['Trade', 'Trade EUB'].includes(OrderDetails?.order_type) && (
                                    <div data-testid="manage-approved-orders-eu-name-card" className="border border-[#CBC7C7] rounded-md bg-[#F5F5FA] overflow-hidden p-3 my-4">
                                        <p className="font-semibold text-base text-[#090406]">End User Customer Name</p>
                                        {OrderDetails?.eu_name ? (
                                            <div className="flex items-center mt-3 pr-3">
                                                <span className="w-7 h-7 rounded-full bg-[#555259] text-white text-xs font-semibold flex items-center justify-center mr-2 flex-shrink-0">
                                                    {OrderDetails?.eu_name?.charAt(0).toUpperCase()}
                                                </span>
                                                <p data-testid="manage-approved-orders-eu-name-value" className="font-normal text-m text-[#555259] truncate min-w-0 max-w-[calc(100%-3ch)]" title={OrderDetails?.eu_name}>{OrderDetails?.eu_name}</p>
                                            </div>
                                        ) : (
                                            <p data-testid="manage-approved-orders-eu-name-empty" className="font-normal text-sm text-[#555259] mt-2">-</p>
                                        )}
                                    </div>
                                )}

                                {/* <!-- Distributor comments --> */}
                                <DistributorComments OrderDetails={OrderDetails} />
                                {OrderDetails?.transfer_history && OrderDetails?.transfer_history?.length > 0 && <TransferHistory OrderDetails={OrderDetails} /> }
                                {/* <!-- Related Documents --> */}
                                <RelatedDocuments OrderDetails={OrderDetails} />
                                {/* <!-- Distributor/customer details --> */}
                                {Object?.values(OrderDetails).length > 0 && <ApprovedOrdersDistributorDetails OrderDetails={OrderDetails} />}
                            </div>
                        </div>

                    </>
                )}
        </div>

    );
}

export default ViewApprovedOrdersDetails;
